import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-quote.css.lit';

/**
 * The Quote component
 * @element outline-quote
 * @slot default - slot for quote
 * @slot attribution -  slot for attribution
 */
@customElement('outline-quote')
export class OutlineQuote extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html` <div class="quote-wrapper">
      <blockquote>
        <slot></slot>
      </blockquote>

      ${this.querySelector('[slot="attribution"]') !== null
        ? html`
            <div class="quote-caption">
              <slot name="attribution"></slot>
            </div>
          `
        : null}
    </div>`;
  }
}
